// Redux selectors for User KPI Management

import { createSelector } from 'reselect';

const selectUserKpiState = (state) => state.userKpi || {};

export const selectUserKpis = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.userKpis || []
);

export const selectSelectedUserKpi = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.selectedUserKpi
);

export const selectUserKpiWithGoals = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.userKpiWithGoals
);

export const selectUserKpiGoals = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.userKpiGoals || []
);

export const selectLoading = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.loading || false
);

export const selectDialogLoading = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.dialogLoading || false
);

export const selectError = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.error
);

export const selectFilters = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.filters || {}
);

export const selectPagination = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.pagination || { limit: 10, offset: 1, total: 0, totalPages: 0 }
);

export const selectDialogs = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.dialogs || {}
);

export const selectDialogData = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.dialogData || {}
);

export const selectUserKpiDialogOpen = createSelector(
    [selectDialogs],
    (dialogs) => dialogs.userKpiDialog || false
);

export const selectManageGoalsDialogOpen = createSelector(
    [selectDialogs],
    (dialogs) => dialogs.manageGoalsDialog || false
);

export const selectDeleteDialogOpen = createSelector(
    [selectDialogs],
    (dialogs) => dialogs.deleteDialog || false
);

export const selectUserKpiToDelete = createSelector(
    [selectDialogData],
    (dialogData) => dialogData.userKpiToDelete
);

export const selectDialogUserKpi = createSelector(
    [selectDialogData],
    (dialogData) => dialogData.userKpi
);

// Dropdown Data Selectors
export const selectAllUsers = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.allUsers || []
);

export const selectUsersForEdit = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.usersForEdit || []
);

export const selectAllPeriods = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.allPeriods || []
);

export const selectAllTemplates = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.allTemplates || []
);

export const selectAllGoals = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.allGoals || []
);

export const selectAllDepartments = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.allDepartments || []
);

export const selectAllDesignations = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.allDesignations || []
);

export const selectAllReportingManagers = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.allReportingManagers || []
);

export const selectAllDirectLineManagers = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.allDirectLineManagers || []
);

export const selectLoadingDropdowns = createSelector(
    [selectUserKpiState],
    (userKpiState) => userKpiState.loadingDropdowns || false
);

export const selectSort = createSelector(
    [selectFilters],
    (filters) => ({
        sortBy: filters.sortBy || 'updatedAt',
        sortDescending: filters.sortDescending !== false
    })
);
